import toBool from 'utils/toBool'
import { z } from 'zod'

const ClinicalAppointmentFields = z.object({
	needEscort: z.boolean().optional().transform(toBool),
	medicalObservation: z.string().optional(),
	notes: z.string().optional(),
})

const schema = (args) => {
	return ClinicalAppointmentFields.refine(
		(data) => !args?.requestEscort || data?.needEscort !== undefined,
		{
			message: 'Required',
			path: ['needEscort'],
		}
	)
}

const strictSchema = (args) => {
	return ClinicalAppointmentFields.strict().refine(
		(data) => !args?.requestEscort || data?.needEscort !== undefined,
		{
			message: 'Required',
			path: ['needEscort'],
		}
	)
}

const managerSchema = (args) => {
	return z
		.object({
			needsOptions: z
				.object({
					housing: z.boolean().optional().transform(toBool),
					transport: z.boolean().optional().transform(toBool),
				})
				.strict()
				.optional()
				.refine(
					(data) =>
						data?.housing !== undefined || !args?.requestEscort,
					{
						message: 'Required',
						path: ['housing'],
					}
				)
				.refine(
					(data) =>
						data?.transport !== undefined || !args?.requestEscort,
					{
						message: 'Required',
						path: ['transport'],
					}
				),
			notes: z.string().optional(),
			chargeAmount: z.number().optional(),
			injuredChargeAmount: z.number().optional(),
			administrativeObservation: z.string().optional(),
			outsideNetwork: z.boolean(),
			externalProvider: z
				.object({
					name: z.string().optional(),
					districtId: z
						.string()
						.optional()
						.transform((val) =>
							val ? parseInt(val, 10) : undefined
						),
				})
				.strict()
				.optional(),
			providerId: z
				.string()
				.optional()
				.transform((val) => (val ? parseInt(val, 10) : undefined)),
		})
		.refine(
			(data) =>
				data?.chargeAmount !== undefined || !args?.requiresChargeAmount,
			{
				message: 'Required',
				path: ['chargeAmount'],
			}
		)
		.refine(
			(data) =>
				data?.injuredChargeAmount !== undefined ||
				!args?.requiresChargeAmount,
			{
				message: 'Required',
				path: ['injuredChargeAmount'],
			}
		)
}

export const ApproveClinicalAppointmentSchema = (args) => schema(args)

export const ClinicalAppointmentApprovalSchema = (args) => strictSchema(args)

export const ExtendedAppointmentApprovalSchema = (args) => managerSchema(args)
